/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', function() {
    var subscribeButton = document.querySelector('.wp-block-ct-newsletter-input .wp-block-button__link');
    var emailInput = document.querySelector('.wp-block-ct-newsletter-input input[type="text"]');

    if (subscribeButton && emailInput) {
        subscribeButton.addEventListener('click', function(event) {
            

            var email = emailInput.value;
            if (email.trim() !== '') {
                var currentUrl = subscribeButton.getAttribute('href');
                var updatedUrl = currentUrl + '?email=' + encodeURIComponent(email);
                subscribeButton.setAttribute('href', updatedUrl);
                
            } else {
                event.preventDefault(); // Empêcher le comportement par défaut du lien
                // Créer un élément span pour le tooltip
                var tooltip = document.createElement('span');
                tooltip.textContent = 'Veuillez saisir une adresse e-mail valide.';
                tooltip.classList.add('tooltip'); // Ajouter une classe pour les styles CSS

                // Ajouter le tooltip à côté de l'input
                var inputParent = emailInput.parentNode;
                inputParent.appendChild(tooltip);

                // Supprimer le tooltip après un certain délai
                setTimeout(function() {
                    tooltip.remove();
                }, 3000); // Supprimez le tooltip après 3 secondes (vous pouvez ajuster cette valeur
            }
        });
    }
});
